export enum UploadTabNames {
  InvoiceForCustomer = "InvoiceForCustomer",
  InvoiceForLandlord = "InvoiceForLandlord",
  Log = "Log",
}
